// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E4QR","left":"styles_left__1iIxc"};